










import { Component, Vue, Prop } from 'vue-property-decorator'
import Counter from '@/components/ui/Counter.vue'

@Component({ name: 'Timer', components: { Counter } })
export default class MyComponent extends Vue {
  @Prop() private color!: string

  private seconds = 0

  private minutes = 0

  private gameStatus = 'Game Started'

  mounted() {
    setInterval(this.updateTime, 1000)
  }

  updateTime() {
    this.seconds += 1
    if (this.seconds === 60) {
      this.minutes += 1
      this.seconds = 0
    }
    if (this.minutes === 60) {
      this.minutes = 0
    }
  }
}
